// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSlidersHorizontal as RawLucideSlidersHorizontal } from "lucide-react";
export const LucideSlidersHorizontal = /* @__PURE__ */ createIcon(RawLucideSlidersHorizontal, "LucideSlidersHorizontal", 2);
